export function validateTimestamp(timestamp: number): boolean {
  const today = new Date();
  const timestampDate = new Date(timestamp * 1000);

  return timestampDate < today;
}
